/* jshint browserify: true */
'use strict';

module.exports = {
    MATH_RENDERER_BASIC: 'Renderer Basic',
    MATH_RENDERER_MATHJAX: 'Renderer MathJax',
    MATH_TEXT_WRAPPERS_INLINE: ['\\(', '\\)'],
    MATH_TEXT_WRAPPERS_BLOCK: ['\\[', '\\]'],

    MATH_NOT_A_MATH_ELEMENT_EXCEPTION: 'This is element is not part of a Math element',
};
